import classNames from "classnames"
import { Typography, withStyles } from "@material-ui/core"
import React from "react"

const styles = (theme) => ({
    li: {
        paddingTop: theme.spacing(0.5),
    },
})

const liMd = ({ classes, className, children }) =>
    <li className={classNames(classes.li, className)}>
        <Typography component={"span"} children={children} />
    </li>

export const LiMd = withStyles(styles)(liMd)